import React from "react";

// Playful vector owl mascot — brand of BrimiAI.
// Big eyes with cyan iris, blue body, orange beak.
export const OwlMascot = ({ size = 96, className = "", talking = false }) => (
  <svg
    viewBox="0 0 128 128"
    width={size}
    height={size}
    className={className}
    aria-label="Brimi the science owl"
    data-testid="owl-mascot"
  >
    <defs>
      <radialGradient id="bodyGrad" cx="50%" cy="35%">
        <stop offset="0%" stopColor="#3b82f6" />
        <stop offset="100%" stopColor="#1d4ed8" />
      </radialGradient>
      <radialGradient id="bellyGrad" cx="50%" cy="60%">
        <stop offset="0%" stopColor="#fde68a" />
        <stop offset="100%" stopColor="#f59e0b" />
      </radialGradient>
    </defs>
    {/* Body */}
    <ellipse cx="64" cy="72" rx="44" ry="46" fill="url(#bodyGrad)" />
    {/* Belly */}
    <ellipse cx="64" cy="82" rx="28" ry="30" fill="url(#bellyGrad)" />
    {/* Ear tufts */}
    <path d="M28 32 L36 12 L46 30 Z" fill="#1d4ed8" />
    <path d="M100 32 L92 12 L82 30 Z" fill="#1d4ed8" />
    {/* Eye whites */}
    <circle cx="46" cy="52" r="18" fill="#f8fafc" />
    <circle cx="82" cy="52" r="18" fill="#f8fafc" />
    {/* Iris */}
    <circle cx="48" cy="54" r="9" fill="#0891b2" />
    <circle cx="80" cy="54" r="9" fill="#0891b2" />
    {/* Pupils */}
    <circle cx="50" cy="55" r="4" fill="#0f172a" />
    <circle cx="78" cy="55" r="4" fill="#0f172a" />
    <circle cx="52" cy="53" r="1.5" fill="#fff" />
    <circle cx="80" cy="53" r="1.5" fill="#fff" />
    {/* Beak */}
    <path
      d="M60 66 L64 76 L68 66 Z"
      fill="#fb923c"
      style={talking ? { transformOrigin: "64px 66px", animation: "swing 0.6s ease-in-out infinite" } : {}}
    />
    {/* Wing */}
    <path d="M22 76 Q28 96 46 96 Q34 90 30 74 Z" fill="#1e40af" />
    <path d="M106 76 Q100 96 82 96 Q94 90 98 74 Z" fill="#1e40af" />
    {/* Feet */}
    <path d="M50 116 L46 122 M54 116 L54 124 M58 116 L62 122" stroke="#fb923c" strokeWidth="3" strokeLinecap="round" />
    <path d="M70 116 L66 122 M74 116 L74 124 M78 116 L82 122" stroke="#fb923c" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

// Compact logo (owl head only) for navbar.
export const BrimiLogo = ({ size = 32, className = "" }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} className={className} data-testid="brimi-logo">
    <circle cx="32" cy="32" r="28" fill="#1d4ed8" />
    <circle cx="24" cy="28" r="9" fill="#f8fafc" />
    <circle cx="40" cy="28" r="9" fill="#f8fafc" />
    <circle cx="25" cy="30" r="4" fill="#0f172a" />
    <circle cx="41" cy="30" r="4" fill="#0f172a" />
    <path d="M28 40 L32 48 L36 40 Z" fill="#fb923c" />
  </svg>
);

export default OwlMascot;
